import React, { useState, useEffect, useContext } from 'react';
import {
	FormControl,
	MenuItem,
	Select,
	TextField,
	InputAdornment,
	ListItemIcon,
	IconButton,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import SearchIcon from '../../assets/SVGs/searchMenuIcon.svg';
import CloseIcon from '../../assets/SVGs/close.svg';
import PropTypes from 'prop-types';
import { useStyles } from './style';
import {
	STORE_DRILL_DOWN_PAGE,
	ITEM_SELECTED,
	ITEM_SELECTED_TEXT,
} from '../../constants/constant';
import { saveEventTrack } from '../../redux/actions/eventTrackAction';
import { UserPortalContext } from '../../context/appcontext';
import { Box } from '@mui/material';
import { colors } from '../../theme/color-palette';
import CheckIcon from '@mui/icons-material/Check';

const { LIGHT_GRAY_HEX } = colors;
export default function ItemFilter({ values, handleChange, selectedValue }) {
	const [open, setOpen] = useState(false);
	const [filterItems, setFilterItems] = useState(values);
	const [searchValue, setSearchValue] = useState('');
	const classes = useStyles({ open });
	const portalUserContext = useContext(UserPortalContext);
	const dispatch = useDispatch();

	useEffect(() => {
		setFilterItems(values);
	}, [values]);

	useEffect(() => {
		if (searchValue === '') {
			setFilterItems(values);
		} else if (searchValue) {
			const filteredItems = values.filter(
				({ node }) =>
					node?.wmItemNbr?.includes(searchValue) ||
					node?.wmItemNm?.toLowerCase().includes(searchValue?.toLowerCase())
			);
			setFilterItems(filteredItems);
		}
	}, [searchValue]);

	const handleOnClose = () => {
		setOpen(false);
	};

	const handleOnOpen = () => {
		setOpen(true);
	};

	const handleOnChange = (e) => {
		if (!isNaN(e?.target?.value) && e?.target?.value?.length >= 9) {
			const selectedItem = values.find(
				({ node }) => node?.wmItemNbr === e?.target?.value
			);
			const request = {
				event: ITEM_SELECTED,
				event_description: `${ITEM_SELECTED_TEXT} ${selectedItem?.node?.wmItemNbr} ${selectedItem?.node?.wmItemNm}`,
				attributes: STORE_DRILL_DOWN_PAGE,
			};

			dispatch(saveEventTrack({ request, portalUserContext }));
			handleChange(e?.target?.value);
		} else {
			setSearchValue('');
		}
	};

	const getRenderValue = () => {
		let valueToReturn = '';

		if (values?.length) {
			const filteredValue =
				values?.filter(({ node }) => node?.wmItemNbr === selectedValue) || [];

			if (filteredValue.length) {
				const [node] = filteredValue;
				const { node: valueToBeDisplayed } = node;
				valueToReturn = `Item: ${valueToBeDisplayed?.wmItemNbr} ${valueToBeDisplayed?.wmItemNm}`;
			}
		}

		return valueToReturn;
	};

	return (
		<FormControl
			className={`${classes.formControl} ${classes.formControlWidth}`}
			size="small"
			data-testid="item-filter-form-control">
			<Select
				data-testid="item-filter"
				id="item-filter"
				value={selectedValue}
				renderValue={() => getRenderValue()}
				onChange={handleOnChange}
				open={open}
				onClose={handleOnClose}
				onOpen={handleOnOpen}
				className={classes.select}
				MenuProps={{
					PaperProps: {
						className: classes.menuPaper,
					},
					className: classes.menu,
					disablePortal: true,
				}}>
				<TextField
					className={classes.searchField}
					type="text"
					value={searchValue}
					name="item-search"
					id="item-search"
					onClick={(e) => e.stopPropagation()}
					onKeyDown={(e) => e.stopPropagation()}
					placeholder="Search"
					data-testid="item-filter-search-field"
					sx={{
						padding: '8px 0',
						margin: '0 8px',
						color: '#2E2F32',
						border: 'none !important',
						width: '-webkit-fill-available',
						'& .MuiFormControl-root': {
							width: '-webkit-fill-available',
						},
						'& .MuiInputBase-root': {
							height: '32px',
						},
					}}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<img src={SearchIcon} alt="search" data-testid="search-icon" />
							</InputAdornment>
						),
						endAdornment: searchValue !== '' && (
							<InputAdornment position="end">
								<IconButton
									onClick={(e) => {
										e.preventDefault();
										setSearchValue('');
									}}
									data-testid="clear-search-button">
									<img src={CloseIcon} alt="clear" />
								</IconButton>
							</InputAdornment>
						),
					}}
					onChange={(e) => {
						e.preventDefault();
						setSearchValue(e.target.value);
					}}
				/>
				{filterItems?.map(({ node: value }) => {
					return (
						<MenuItem
							key={value?.wmItemNbr}
							value={value?.wmItemNbr}
							data-test={`item-filter-${value?.wmItemNbr}`}
							data-testid={`item-filter-menu-item-${value?.wmItemNbr}`}
							className={classes.menuItem}>
							<ListItemIcon
								data-testid={`item-filter-icon-${value?.wmItemNbr}`}>
								{selectedValue === value.wmItemNbr ? (
									<CheckIcon
										style={{
											height: '16px',
											width: '16px',
											color: LIGHT_GRAY_HEX,
										}}
										data-testid={`item-filter-check-icon-${value?.wmItemNbr}`}
									/>
								) : (
									<Box></Box>
								)}
							</ListItemIcon>
							Item: {`${value?.wmItemNbr} ${value?.wmItemNm}`}
						</MenuItem>
					);
				})}
			</Select>
		</FormControl>
	);
}

ItemFilter.propTypes = {
	values: PropTypes.array,
	handleChange: PropTypes.func,
	selectedValue: PropTypes.string,
};
